import { render, staticRenderFns } from "./RadioListItem.vue?vue&type=template&id=70171b46&scoped=true&"
import script from "./RadioListItem.vue?vue&type=script&lang=js&"
export * from "./RadioListItem.vue?vue&type=script&lang=js&"
import style0 from "./RadioListItem.vue?vue&type=style&index=0&id=70171b46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70171b46",
  null
  
)

export default component.exports